<template>
  <img
    v-if="!useInitial"
    :src="faviconLink"
    loading="lazy"
    :alt="hostname + ' logo'"
    :style="style"
    @error="useInitial = true"
  >
  <div
    v-else
    class="bg-dark text-white border rounded-circle font-weight-bold flex-center-center"
    :style="style"
  >
    {{ urlInitial }}
  </div>
</template>

<script>
export default {
  name: "Favicon",

  props: {
    hostname: {
      type: String,
      default: "",
    },

    size: {
      type: String,
      default: "32px",
    },

    url: {
      type: String,
      required: true,
    },

    useRawUrl: {
      type: Boolean,
      required: false,
    },
  },

  data: () => ({
    useInitial: false,
  }),

  computed: {
    /**
     * Get the favicon link from third-party service.
     * 
     * @see https://www.google.com/s2/favicons?sz=64&domain_url=${hostname}
     * @see https://icons.duckduckgo.com/ip3/${hostname}.ico
     * 
     * @returns {string} Favicon link
     */
    faviconLink() {
      return `https://icons.duckduckgo.com/ip3/${this.hostname}.ico`;
    },

    urlInitial() {
      return this.url.charAt(0).toUpperCase();
    },

    style() {
      return {
        height: this.size,
        width: this.size,
        "min-width": this.size,
        flex: `0 0 ${this.size}`,
      };
    },
  },

  watch: {
    hostname() {
      this.verifyHostname();
    },
  },

  created() {
    this.verifyHostname();
  },

  methods: {
    verifyHostname() {
      this.useInitial = this.hostname === "";
    },
  },
};
</script>
